import { CustomerDocument } from '../../graphql/customer.generated';

import type { CustomerQuery } from '../../graphql/customer.generated';
import type { Client, RequestPolicy } from 'urql';

// ─────────────────────────────────────────────────────────────────────────────

export async function customerQuery(
  client: Client,
  requestPolicy: RequestPolicy = 'cache-and-network',
) {
  return client.query<CustomerQuery>(CustomerDocument, {}, { requestPolicy }).toPromise();
}
